























































































































































































import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalText from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumText from '@/components/common/control/CtrlNumTxt.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlRadioMukoFlg from '@/components/common/control/CtrlRadioMukoFlg.vue';
import MstMenteToolBar from '@/components/common/control/CtrlMstMenteToolBar.vue';
//import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
//import CtrlSelect from '@/components/common/control/CtrlSelect.vue';
import { BUTTON } from '@/constants/label';
// UmuFlgが必要かはもう少しあとで
//import { ShoriKb, UmuFlg, MukoFlg, OutStatus, MeishoBunruiCd, KaFukaFlg, } from '@/constants/constants';
import { ShoriKb, UmuFlg, MukoFlg, OutStatus, } from '@/constants/constants';
import {
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
  isShorikbDELCANCEL,
} from '@/utils/utils';
import {
  haisoMstType,
} from '@/types/G_kaigai/G_150_HaisoMstMente';

export default Vue.extend<any, any, any, any>({
  name: 'N_G150_HaisoMstMente_ChildHeaderInput',
  components: {
    CtrlNormalBtn,
    CtrlNormalText,
    CtrlNumText,
    CtrlMessageDialog,
    MstMenteToolBar,
    CtrlRadioMukoFlg,
//    CtrlHimmoku,
//    CtrlSelect,
  },
  props: {
    show: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
  },
  data: () => ({
    ShoriKb,
    BUTTON: BUTTON,
    datetime: '',
    isCreated: false,
    isDelete: false,
    isDialogOpen: true,
    cMessage: false,
    cMessageId: '',
    cMessageTextParam: [] as string[],
    UmuFlg,
    radioGroup: 1,
    wMessage: false,
    wMessageId: '',
    wMessageTextParam: [] as string[],
    detailItem: {} as haisoMstType,

    isReloadStopFlg: false,
    isHideCancel: false,
    MukoFlg,
 //   MeishoBunruiCd,
  }),
  methods: {
    handleChangeItakusakiCd(val: string) {
      this.formItem.itakusakiCd = Number(val);
    },
    handleChangeItakusakiMei1(val: string) {
      this.formItem.itakusakiMei1 = val;
    },
    handleChangeItakusakiMei2(val: string) {
      this.formItem.itakusakiMei2 = val;
    },
    handleChangeItakusakiRyakuMei(val: string) {
      this.formItem.itakusakiRyakuMei = val;
    },
    handleChangeUnsoSashizushoBiko1(val: string) {
      this.formItem.unsoSashizushoBiko1 = val;
    },
    handleChangeUnsoSashizushoBiko2(val: string) {
      this.formItem.unsoSashizushoBiko2 = val;
    },
    handleChangeUnsoSashizushoBiko3(val: string) {
      this.formItem.unsoSashizushoBiko3 = val;
    },
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    // 保存 button click
    async handleSave() {
      // タイマー入れる
      await new Promise((resolve) => setTimeout(resolve, 300));
      //必須項目などのrulesチェックを行う
      this.$refs.form.validate();

      // 個別必須チェック
      //    {0}は必須入力です
      if (!this.formItem.itakusakiCd) {
        this.cMessage = true;
        this.cMessageId = 'KI_W100';
        this.cMessageTextParam = ['配送会社コード'];
        return;
      }
      if (!this.formItem.itakusakiMei1) {
        this.cMessage = true;
        this.cMessageId = 'KI_W100';
        this.cMessageTextParam = ['配送会社名１'];
        return;
      }
      if (!this.formItem.itakusakiRyakuMei) {
        this.cMessage = true;
        this.cMessageId = 'KI_W100';
        this.cMessageTextParam = ['配送会社略名'];
        return;
      }

      // 処理区分が[削除取消] で、[有効] を選択してない場合
      //    無効を選択している場合は、'削除取消できません。
      //if (this.isDelCancel && this.formItem.mukoFlg) {
      if (this.isDelCancel && this.radioGroup) {
        this.cMessage = true;
        this.cMessageId = 'KI_W110';
        this.cMessageTextParam = ['無効', '削除取消'];
        return;
      }
      // 該当データ無 等の場合「入力内容に誤りがあります」を表示する
      if (!this.$refs.form.validate()) {
        this.cMessageId = 'KI_W121';
        this.cMessageTextParam = [];
        this.cMessage = true;
        return;
      }
      // [追加 or 変更] します。\nよろしいですか？
      this.cMessage = true;
      this.cMessageId = 'KI_Q100';
      this.cMessageTextParam = [this.isAdd ? '追加' : '変更'];
    },

    // 全ての message dialog で [OK button] click した場合の処理を、ここにまとめる
    //    response error 用 message dialog は対象外
    async handleMessageDialogOk() {
      // message dialog を閉じる
      this.cMessage = false;

      if (!this.$refs.form.validate()) {
        return;
      }

      // [追加 or 変更] します。\nよろしいですか？
      if (this.cMessageId === 'KI_Q100') {
        // ローディング・スタート
        this.$store.dispatch('common/setIsLoading', true);
        // request body 組み立て
        const commonInfo = {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          riyoshaCd: this.userInfo.riyoshaCd,
        };

        // POST, PUT 共通の項目
        const haisoMstData: any = {
          itakusakiCd: this.formItem.itakusakiCd,
          itakusakiMei1: this.formItem.itakusakiMei1,
          itakusakiMei2: this.formItem.itakusakiMei2,
          itakusakiRyakuMei: this.formItem.itakusakiRyakuMei,
          unsoSashizushoBiko1: this.formItem.unsoSashizushoBiko1,
          unsoSashizushoBiko2: this.formItem.unsoSashizushoBiko2,
          unsoSashizushoBiko3: this.formItem.unsoSashizushoBiko3,
        };
        // PUT の場合、[更新回数] と [無効FLG] を追RRする
        if (this.isUpd || this.isDelCancel) {
          haisoMstData.koshinCount = this.formItem.koshinCount;
          haisoMstData.mukoFlg = this.radioGroup; //this.formItem.mukoFlg;
        }
        const requestBody: any = {
          requestData: {
            commonInfo: commonInfo,
            haisoMstData: haisoMstData,
          },
        };
        const response = await this.$store.dispatch(
          'g150/postPutHaisoMst',
          {
            requestBody,
            shoriKb: this.shoriKb,
          }
        );

        if (
          response &&
          response.status == 200 &&
          response.data &&
          response.data.error &&
          response.data.error.outStatus &&
          response.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.wMessageId = response.data.error.messageID;
          this.wMessageTextParam = response.data.error.messageArgs;
          this.wMessage = true;

          // [OutStatus.CHECK_ERR] は、自画面を閉じない
          if (response.data.error.outStatus == OutStatus.CHECK_ERR) {
            this.isHideCancel = true;
          }
          // ローディング・ストップ
          this.$store.dispatch('common/setIsLoading', false);
          return;
        }
        // ローディング・ストップ
        this.$store.dispatch('common/setIsLoading', false);

        // ヘッダ入力画面を閉じて、問合せ画面の reset icon 処理を実行させる
        this.hide();
        return;
      }

      // 削除します、よろしいですか？
      if (this.cMessageId === 'KI_Q104') {
        // ローディング・スタート
        this.$store.dispatch('common/setIsLoading', true);
        // request body 組み立て
        const commonInfo = {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          riyoshaCd: this.userInfo.riyoshaCd,
        };

        // 配送会社マスタの項目
        const haisoMstData: any = {
          itakusakiCd: this.formItem.itakusakiCd,
          koshinCount: this.formItem.koshinCount,
        };
        const requestBody: any = {
          requestData: {
            commonInfo: commonInfo,
            haisoMstData: haisoMstData,
          },
        };
        const response = await this.$store.dispatch(
          'g150/deleteHaisoMst',
          {
            requestBody,
            shoriKb: this.shoriKb,
          }
        );

        if (
          response &&
          response.status == 200 &&
          response.data &&
          response.data.error &&
          response.data.error.outStatus &&
          response.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.wMessageId = response.data.error.messageID;
          this.wMessageTextParam = response.data.error.messageArgs;
          this.wMessage = true;

          // [OutStatus.CHECK_ERR] は、自画面を閉じない
          if (response.data.error.outStatus == OutStatus.CHECK_ERR) {
            this.isHideCancel = true;
          }
          // ローディング・ストップ
          this.$store.dispatch('common/setIsLoading', false);
          return;
        }
        // ローディング・ストップ
        this.$store.dispatch('common/setIsLoading', false);

        // ヘッダ入力画面を閉じて、問合せ画面の reset icon 処理を実行させる
        this.hide();
        return;
      }
    },

    // 配送会社コード" の 入力値を formItem に設定
    handleCallbackOkitakusakiCd(itakusaki: any) {
      this.formItem.itakusakiCd = itakusaki.itakusakiCd;
    },
    // 通常の message dialog で キャンセル click
    handleExit() {
      this.cMessage = false;
      this.cMessageId = '';
      this.cMessageTextParam = [];
    },
    // response error の場合の message dialog で OK click
    handleWarnExit() {
      // error の場合は、無条件で reset icon click 処理を行う
      this.wMessage = false;
      this.wMessageId = '';
      this.wMessageTextParam = [];

      if (this.isHideCancel) {
        //自画面を閉じない
        this.isHideCancel = false;
        return;
      }

      if (this.isReloadStopFlg) {
        // 自画面を閉じて、問合せ画面の再検索を行わない（現在の仕様では発生していない）
        this.hide(false);
      } else {
        // 自画面を閉じて、問合せ画面の再検索を行う
        this.hide();
      }
    },
    // キャンセル button click
    handleCancel() {
      // キャンセル は、確認無しで自画面を閉じて、問合せ画面の再検索を行わない
      this.hide(false);
    },
    // 削除 button click
    handleDelete() {
      this.cMessageId = 'KI_Q104';
      this.cMessageTextParam = ['削除'];
      this.cMessage = true;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleChangeRadioGroup(value: any) {
      // 0:有効, 1:無効
      this.radioGroup = value;
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      meishoMstList: 'common/meishoMstList',    // 有効・無効で使用している？
      formItem: 'g150/haisoMst',
      childHeaderTitle: 'common/childHeaderTitle',
    }),
    isDeleteDisabled() {
      if (!isShorikbUPD(this.shoriKb)) {
        return true;
      } else {
        return false;
      }
    },
    isSaveDisabled() {
      if (isShorikbREFER(this.shoriKb) && !isShorikbADD(this.shoriKb)) {
        return true;
      } else {
        return false;
      }
    },
    checkTime() {
      if (!isShorikbADD(this.shoriKb)) {
        return moment(this.item.koshinDate).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '';
      }
    },
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
    isDelCancel() {
      return isShorikbDELCANCEL(this.shoriKb);
    },
    computedTargetYmd() {
      return Number(moment().format('YYYYMMDD'));
    },
  },
  async created() {
    this.$store.dispatch('common/getMeishoMaster', {
      mukoUmuFlg: isShorikbREFER(this.shoriKb) ? UmuFlg.ARI : UmuFlg.NASHI,
    });
    if (!this.isAdd) {
      const response = await this.$store.dispatch(
        // 更新回数のチェックがあるので一覧画面で必要項目満たしていても再取得が必要
        'g150/getHaisoMst',
        {
          itakusakiCd: this.item.itakusakiCd,
        }
      );

      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        // 自画面を閉じて、再検索
        this.wMessageId = response.data.error.messageID;
        this.wMessageTextParam = response.data.error.messageArgs;
        this.wMessage = true;
        return;
      }

      // 更新回数チェック
      if (isShorikbUPD(this.shoriKb) || isShorikbDELCANCEL(this.shoriKb)) {
        if (response.data.responseData.koshinCount !== this.item.koshinCount) {
          // 自画面を閉じて、再検索
          this.wMessageId = 'KI_W107';
          this.wMessage = true;
          return;
        }
      }

      this.radioGroup = this.formItem.mukoFlg;
    }
  },
  beforeDestroy() {
      this.$store.dispatch('g150/resetHaisoMst');
  },
});
